import React from 'react';
import {
  CContainer, CRow, CCol, CCard, CCardBody, CCardHeader,
  CBreadcrumb, CBreadcrumbItem
} from '@coreui/react';
import { useNavigate } from 'react-router-dom';
import ThreadInputs from '../../components/ThreadInputs/ThreadInputs';
import { connect } from 'react-redux';
import { createThreadRequestAction } from '../../store/thread/threadActions';
import { useTranslation } from '../../hooks/useTranslation';
const CreateThread = ({ createThreadRequest, isLoading, createThreadData }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const handleSubmit = (data) => {
    createThreadRequest({ data, navigate });
  };

  const handleCancel = () => {
    navigate('/thread');
  };

  return (
    <CContainer>
      <CBreadcrumb className="mb-4">
        <CBreadcrumbItem href="#/thread" onClick={(e) => { e.preventDefault(); handleCancel(); }}>
          {t('thread')}
        </CBreadcrumbItem>
        <CBreadcrumbItem active>{t('createThread')}</CBreadcrumbItem>
      </CBreadcrumb>

      <CRow>
        <CCol xs={12}>
          <CCard>
            <CCardHeader><h4>{t('createThread')}</h4></CCardHeader>
            <CCardBody>
              <ThreadInputs
                onSubmit={handleSubmit}
                onCancel={handleCancel}
                isLoading={isLoading}
                submitResponse={createThreadData}
              />
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  );
};

const mapStateToProps = (state) => ({
  isLoading: state.loadingReducer.isLoading,
  createThreadData: state.threadReducer.createThreadData,
});

const mapDispatchToProps = (dispatch) => ({
  createThreadRequest: (payload) => dispatch(createThreadRequestAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateThread);
